<template>
    <modal :title="$t(newTitle)" :visible.sync="isShowDialog" width="50%">
        <div class="detail_t">
            <div class="content_t_l">
                <!-- 表单 -->
                <carrierForm ref="carrierForm" v-bind="$attrs" :isMode="isMode" :handleText="handleText" />
            </div>
            <!-- 图片 -->
            <div :class="isMode ? 'nocontent_t_r' : 'content_t_r'">
                <carrierUpload @uploadFn="uploadFn" ref="upload" v-bind="$attrs" v-show="!isMode" />
                <img v-show="isMode" :src="$attrs.detailContent.pictureBase64" />
                <div v-if="isShowMsg" class="el-form-item__error">{{$t('integration.picture_cannot_be_empty')}}</div>
            </div>
            <div class="handleIcon" v-if="handleText !== 'add'">
                <i :class="isMode ? 'el-icon-edit' : 'el-icon-back'" @click="modeChange"></i>
            </div>
        </div>
        <!-- tabs -->
        <carrierTab @handleTabs="handleTabs" :activeCom.sync="activeCom" />
        <!-- 表格 -->
        <div class="content_b">
            <Attribute v-show="activeCom === 'Attribute'" ref="Attribute" v-bind="$attrs" :isMode="isMode"
                :handleText="handleText" />
            <Application v-show="activeCom === 'Application'" ref="Application" v-bind="$attrs" :isMode="isMode" />
            <!-- <Attribute /> -->
            <!-- <component :is="activeCom" ref="component" /> -->
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave" v-show="!isMode">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import carrierForm from './components/carrierForm.vue';
import carrierUpload from './components/carrierUpload.vue';
import carrierTab from './components/carrierTab.vue';
import Attribute from './components/Attribute.vue';
import Application from './components/Application.vue';

import { carrierTypeAdd, carrierTypeEdited } from '@/api/modules/carrierType.js';
export default {
    props: ['title', 'isShow', 'handleText'],
    components: {
        carrierForm,
        carrierUpload,
        carrierTab,
        Attribute,
        Application
    },
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow
            },
            set: function (val) {
                this.$emit('update:isShow', val) //可以优化成model  或者minx
            }
        },
    },
    watch: {
        handleText(newVal) {
            if (newVal === 'add') {
                this.isMode = false;
            } else {
                this.isMode = true
            }
        },
        title(newVal) {
            this.newTitle = newVal;
        }
    },
    data() {
        return {
            activeCom: 'Attribute',
            isShowMsg: false,
            isMode: true,
            newTitle: ''
        }
    },
    methods: {
        uploadFn(bool) {
            this.isShowMsg = !bool;
        },
        handleTabs(name) {
            this.activeCom = name;
        },
        modeChange() {
            this.isMode = !this.isMode;
            if (this.isMode) {
                this.newTitle = $t('integration.mount_type_details')
            } else {
                this.newTitle = $t('integration.edit_mount_type')
            }
        },
        // 清除数据以及校验
        clearValidate() {
            this.activeCom = 'Attribute';
            this.$refs['upload'].imageSuffix = '';
            this.$refs['upload'].imageUrl = '';
            this.isShowMsg = false;
            this.$refs['carrierForm'].clearValidate();
            this.$refs['Attribute'].clearValidate();
            this.$refs['Application'].choozeValue = [];
        },
        async handleSave() {
            const { imageSuffix, imageUrl } = this.$refs['upload'];
            const { dioForm } = this.$refs['carrierForm'];
            const { tableForm } = this.$refs['Attribute'];
            const { choozeValue } = this.$refs['Application'];

            const flag1 = await this.$refs['carrierForm'].justify();
            const flag2 = await this.$refs['Attribute'].justify();

            this.isShowMsg = !imageUrl ? true : false;
            if (!flag1 || !flag2 || this.isShowMsg) return
            if (choozeValue.length === 0) return this.$message.warning($t('integration.select_at_least_one_application_object'));
            let Query = {}
            Query = { ...dioForm };
            // 图片
            Query.uploadFileBase64 = imageUrl;
            Query.uploadFileSuffix = imageSuffix;
            // 属性
            Query.carrierTypePropertyList = tableForm.tableData;
            // 应用
            Query.carrierTypeApplyList = choozeValue.map(item => ({ sceneId: item }));

            let httpUrl = carrierTypeAdd
            if (this.handleText !== 'add') {
                httpUrl = carrierTypeEdited;

            } else {
                delete Query.id;
            }



            if (Query.status === '0') {
                this.$confirm(
                    this.$t('public.tip_confirm'),
                    this.$t('integration.tips'),
                    {
                        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                        type: 'warning',
                    }
                ).then(() => {
                    this.httpFn(httpUrl, Query)
                }).catch(() => { })
            } else {
                this.httpFn(httpUrl, Query)
            }
        },
        httpFn(url, Query) {
            url(Query).then(({ result }) => {
                if (result) {
                    this.$message.success(this.$t('public.tip_oper_succ'));
                    this.isShowDialog = false;
                    this.$parent.getListFn();
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.detail_t {
    display: flex;

    .content_t_l {
        flex: 1;
    }

    .content_t_r,
    .nocontent_t_r {
        width: 200px;
        height: 200px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        position: relative;

        &::before {
            content: '*';
            position: absolute;
            left: -10px;
            color: red;
            margin-right: 4px;
        }

        img {
            width: 100%;
            height: 100%;
            display: block;
        }

    }

    .nocontent_t_r {
        &::before {
            content: '';
        }
    }

    .handleIcon {
        width: 30px;
        height: 100%;
        text-align: center;
        cursor: pointer;

        i {

            &:hover {
                color: red
            }
        }
    }
}
</style>